import { useEffect, useState } from "react";
import type {} from "../types/global";
import { axiosInstance } from "../axios-instance";
import { extractMsalTokenFromCookie } from "./msal-cookie-extractor";

type CookieRequestInterceptorProps = {
  children: React.ReactNode;
};

const CookieRequestInterceptor: React.FC<CookieRequestInterceptorProps> = ({
  children,
}) => {
  const [interceptorLoaded, setInterceptorLoaded] = useState(false);

  useEffect(() => {
    const getMsalToken = async () => {
      const accessToken = extractMsalTokenFromCookie();

      return Promise.resolve({
        accessToken,
      });
    };

    window.getAccessToken = getMsalToken;

    const interceptorId = axiosInstance.interceptors.request.use(
      async (config) => {
        const tokenData = await getMsalToken();
        config.headers.Authorization = tokenData.accessToken;

        return config;
      }
    );

    setInterceptorLoaded(true);

    return () => {
      axiosInstance.interceptors.request.eject(interceptorId);
      window.getAccessToken = undefined;
    };
  }, [setInterceptorLoaded]);

  if (!interceptorLoaded) {
    return <></>;
  }

  return <>{children}</>;
};

export default CookieRequestInterceptor;
